import { createSearchClient, createStrictSearchClient } from 'lib/searchblox';

export const useSearchClient = () => {
  const config = {
    endpoint: process.env.SEARCHBLOX_ENDPOINT || '',
    querykey: process.env.SEARCHBLOX_QUERY_KEY || '',
    col: process.env.SEARCHBLOX_COLLECTION_NUMBER || '',
  };

  const searchClient = createSearchClient(config);
  // Throwing variant reserved for facet-bearing queries (see disjunctiveFacets.ts).
  const strictSearchClient = createStrictSearchClient(config);

  return {
    searchClient,
    strictSearchClient,
  };
};
